import store from "store2";
export default {
  name: "wechat-quick-login",
  props: {
    login: {
      type: Object,
      default() {
        return {};
      }
    },
    sendMessage: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      userInitLogo: "https://app-1251575231.cos.ap-shanghai.myqcloud.com/portal/apps/head.jpg",
      savedUserInfo: store.get("userInfo") || {}
    };
  },
  computed: {
    savedUserImg() {
      var _this$savedUserInfo;
      return ((_this$savedUserInfo = this.savedUserInfo) === null || _this$savedUserInfo === void 0 ? void 0 : _this$savedUserInfo.picture) || this.userInitLogo;
    }
  },
  methods: {
    savedLogin() {
      this.$emit("saved-login");
    },
    onBackLoginMain() {
      let emitValue = {
        showEWM: true,
        loginType: "MOBILE"
      };
      this.$emit("on-change", emitValue);
    }
  }
};